import sourceId from './sourceId'
const storageKey = 'plickers-tab-sync'

function wrapAction(action) {
	return {
		action,
		sourceId,
		time: Date.now(),
		fromStorage:true,
	}
}




export function storageMiddleware() {
	return () => next => action => {
		if(action && action.syncAction===true){		//we only want to sync some actions 
			const wrappedAction = wrapAction(action)
			localStorage.setItem(
				storageKey,
				JSON.stringify(wrappedAction)
			)
		}
		next(action)
	}

}


export function createOnStorage(store) {
	return () => {
		const wrappedAction = JSON.parse(localStorage.getItem(storageKey))
		if (wrappedAction && wrappedAction.sourceId !== sourceId) {
			store.dispatch({...wrappedAction.action,syncAction:false})
		}
	}
}



// WEBPACK FOOTER //
// ./src/tabSyncMiddleware.js